import { ReactNode } from "react";
import { matchPath } from "react-router-dom";
import {
  Permission,
  permissionGroupArray,
  userManagementPermissionArray,
} from "../../shared/enumeration/permission";
import BellSidebarIcon from "../shared/icons/BellSidebarIcon";
import EmailIcon from "../shared/icons/EmailIcon";
import HeadphonesIcon from "../shared/icons/HeadphonesIcon";
import InfoCircleSidebar from "../shared/icons/InfoCircleSidebar";
import LockIcon from "../shared/icons/LockIcon";
import MessageAlertSquareSidebar from "../shared/icons/MessageAlertSquareSidebar";
import MessageSquareIcon from "../shared/icons/sidebar/MessageSquareIcon";
import UserCircleIcon from "../shared/icons/UserCircleIcon";
import UserGroup from "../shared/icons/UserGroup";

export const checkMatchPath = (pathArray: string[], pathName: string) => {
  let isActive = false;
  pathArray.forEach((path) => {
    const isMatch = matchPath({ path, end: false }, pathName);
    if (Boolean(isMatch)) {
      isActive = true;
      return;
    }
  });
  return isActive;
};
export interface SidebarItem {
  name: string;
  to: string;
  icon?: ReactNode;
  isTitle?: boolean;
  subItems?: SidebarItem[];
  permissions?: Permission[];
  count?: number;
}

export const defaultSiderbarItems: SidebarItem[] = [
  {
    name: "Danh sách thành viên",
    to: "/admin/users",
    icon: <i className="fa-solid fa-user" style={{ fontSize: 18 }}></i>,
  },
  {
    name: "Lịch sử giao dịch",
    to: "/admin/transaction",
    icon: (
      <i
        className="fa-solid fa-circle-dollar-to-slot"
        style={{ fontSize: 18 }}
      ></i>
    ),
  },

  {
    name: "CSKH",
    to: "/admin/message",
    icon: <i className="fa-solid fa-headset" style={{ fontSize: 18 }}></i>,
  },
  {
    name: "Cấu hình hệ thống",
    to: "/admin/settings",
    icon: <i className="fa-solid fa-gear" style={{ fontSize: 18 }}></i>,
  },
];

export const userSettingSidebarItems: SidebarItem[] = [
  {
    name: "Thông tin hệ thống",
    to: "/system-info",
    icon: <InfoCircleSidebar className="custom-nav-icon" />,
  },
  {
    name: "Quyền",
    to: "/permissions",
    icon: <UserGroup className="custom-nav-icon" />,
    permissions: permissionGroupArray,
  },
  {
    name: "Tài khoản",
    to: "/users",
    icon: <UserCircleIcon className="custom-nav-icon" />,
    permissions: userManagementPermissionArray,
  },
  {
    name: "Cài đặt kế hoạch và thông báo",
    to: "/plan-notification-setting",
    icon: <BellSidebarIcon className="custom-nav-icon" />,
  },
  {
    name: "Hỗ trợ",
    to: "/support",
    icon: <MessageAlertSquareSidebar className="custom-nav-icon" />,
  },
];

export const accountSettingSidebarItems: SidebarItem[] = [
  {
    name: "Thông tin tài khoản",
    to: "/account/profile",
    icon: <UserCircleIcon className="custom-nav-icon" />,
  },
  {
    name: "Thay đổi mật khẩu",
    to: "/account/change-password",
    icon: <LockIcon className="custom-nav-icon" />,
  },
  {
    name: "Thay đổi email",
    to: "/account/change-email",
    icon: <EmailIcon className="custom-nav-icon" />,
  },
  {
    name: "Hỗ trợ",
    to: "/account/support",
    icon: <HeadphonesIcon className="custom-nav-icon" />,
  },
];

export const handleSidebarItemsOnPathName = (path: string) => {
  if (
    checkMatchPath(
      userSettingSidebarItems.map((item) => item.to),
      path
    )
  ) {
    return userSettingSidebarItems;
  }

  if (
    checkMatchPath(
      accountSettingSidebarItems.map((item) => item.to),
      path
    )
  ) {
    return accountSettingSidebarItems;
  }
};

interface ITabItem {
  name: ReactNode;
  path: string;
}

export interface HeaderItem {
  name: ReactNode;
  to: string;
  tabItems?: ITabItem[];
  rightComponent?: ReactNode;
}

export const otherHeaderItem: HeaderItem[] = [
  {
    name: "Cài đặt hệ thống",
    to: "/settings",
    tabItems: [
      { name: "Thông tin hệ thống", path: "/settings/system-info" },
      { name: "Quyền", path: "/settings/permissions" },
      { name: "Tài khoản", path: "/settings/users" },
    ],
  },
  {
    name: "Tài khoản của tôi",
    to: "/account",
    tabItems: [
      { name: "Thông tin", path: "/account/profile" },
      { name: "Bảo mật", path: "/account/change-password" },
      { name: "Thông báo", path: "/account/notifications" },
    ],
  },
];

export const handleGetHeaderItem = (path: string) => {
  const siderBarItem = [...defaultSiderbarItems];
  const convertSideBarItem = siderBarItem.map(({ name, to }) => ({ name, to }));
  const allHeaderItem = [...otherHeaderItem, ...convertSideBarItem];
  const headerItem = allHeaderItem.find((item) =>
    checkMatchPath([item.to], path)
  );
  if (headerItem) {
    return headerItem;
  }
  return null;
};
